module.exports = __webpack_public_path__ + "img/24_59.eb465126.png";